import * as S from './styled';

function AccountStatBoxIcon ({ children, clearBG }) {
  return <S.Container clearBG={clearBG}>
    {children}
  </S.Container>;
}

export default AccountStatBoxIcon;
